import { DataTableSkeleton } from '@Components/General/Skeletons';
import { createFileRoute } from '@tanstack/react-router';
import { expensesQueryOptions } from '@utils/queryOptions';
import Expenses from '@Views/Expenses/Expenses';

export const Route = createFileRoute('/expenses/')({
    component: Expenses,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            expensesQueryOptions(opts.deps),
        ),
    loaderDeps: ({ search }) => search,
    pendingComponent: DataTableSkeleton,
});
